import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
/**
 * コラムサイドメニュー：「人気の選定支援事例」のスケルトンコンポーネント
 * @param props
 * @constructor
 */
export const PopularCaseListItemSkeleton = (props) => {
    const { className } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex gap-x-[10px]', className) }, { children: [_jsx(Skeleton, { className: 'shrink-0 w-[120px] h-[75px]' }), _jsx(Skeleton, { className: clsx('w-full h-[48px]') })] })));
};
